import { TEAM_DETAILS_LIST } from "../actions";

export const teamDetailsListReducer = (state = {}, action) => {
  if (action.type === TEAM_DETAILS_LIST) return action.payload;
  return state;
};
